import script from "./Notification.vue?vue&type=script&setup=true&lang=js"
export * from "./Notification.vue?vue&type=script&setup=true&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=2194bd7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2194bd7a"]])

export default __exports__